import React, { useEffect, useState } from 'react';
import PageTitle from 'components/atoms/PageTitle';
import Button from 'components/atoms/Button';
import CodeInput from 'components/atoms/CodeInput';
import infoIcon from '../../../../assets/svg/info-circle-danger.svg';
// import AppModal from '../../../../components/organisms/CustomModal'; // No longer needed
import Prompts from 'components/atoms/Prompts';
import { connect } from 'react-redux';
import { cancelFileUpload, setBatchID } from '../../../../redux/app/app.action';
import Alert from 'components/atoms/Alert';
import { useLocation, useNavigate } from 'react-router-dom';
import CountdownTimer from 'components/atoms/CountDown';
import { handleException, encryptPayload } from 'utils';
import axios from 'services/axios';
import { getValues } from 'services/storage';
import Spinner from 'components/atoms/Spinner';
// import seerbit_logo_boxed_grey from '../../../../assets/svg/seerbit_logo_boxed_grey.svg';
// import close_x from '../../../../assets/svg/close_x.svg';
// import send_money_gif from '../../../../assets/svg/send_money_.gif'; // No longer needed - moved to success page
import { PocketUserActionEnum, PocketUserEnum } from 'types';
import {
  seAlltPocketDetails,
  setDashboardAnalytics,
} from 'redux/pocket/pocket.action';

const ValidateOTP = (props) => {
  const [OTP, setOTP] = React.useState('');
  const [loading, setLoading] = useState(false);
  const [OTPChange, setOTPChange] = useState('');
  const [OTPErr, setOTPErr] = useState('');
  const [transactionMode, setTransactionMode] = useState('');

  const navigate = useNavigate();

  const location: any = useLocation();
  const fileAvailable = location?.state?.fileData ? true : false;

  useEffect(() => {
    if (fileAvailable === false) {
      navigate('/dashboard/disbursement/single');
    } else {
      setTransactionMode(location?.state?.mode);
    }
  }, [navigate, location]);

  const [showPrompt, setShowPrompt] = useState(false);
  const promptSetting = {
    icon: infoIcon,
    iconStyle: 'bg-DangerAccent4',
    BgColor: 'white',
    loadColor: 'bg-Danger3',
    message: 'Tarminate Transaction',
    subMessage:
      'This action would cancel the transaction process and remove the uploaded file from memory, do you wish to continue?',
  };

  const getAnalytics = async () => {
    try {
      const { data } = await axios.get(
        `https://pocket.seerbitapi.com/winner/dashboard/${props.pocket_data?.pocketId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${props.bearerToken}`,
          },
        }
      );
      if (data.status === '00') {
        const details = data.PrimaryPocket || data.Cell;
        props.setDashboardAnalytics({ ...details });
      } else {
        // Alert('error', data.message);
      }
    } catch (err: any) {
      // Alert('error', err.message);
    }
  };

  const checkAllPrimaryPockets = async () => {
    try {
      const res = await axios.get(
        `https://pocket.seerbitapi.com/pocket/multiple-pockets/${
          props.pocket_data?.pocketCredentials?.userName ||
          props.primaryPocket_details?.pocketOwner?.emailAddress
        }`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${props.bearerToken}`,
            'Public-Key': `${props.public_key}`,
          },
        }
      );

      if (res.data.code === 'error') {
        // Alert('error', res.data.message);
      } else {
        // console.log(res.data, 'all primary pockets');
        // setPocketData({ ...pocket_data, allPrimaryPockets: res.data });
        props.seAlltPocketDetails(res.data);
        // setValues('allPrimaryPockets', []);
      }

      return res;
    } catch (error) {
      // handleException(error);
    }
  };

  const userName = getValues('username');
  const accountType = getValues('pocketType');
  const actionItemValue =
    accountType === PocketUserEnum.PRIMARY_POCKET
      ? PocketUserActionEnum.APPROVE_DISBURSEMENT_BY_HEAD_CHURCH
      : PocketUserActionEnum.APPROVE_DISBURSEMENT_BY_OUTLET;

  const handleOTPComplete = (p) => {
    setOTP(p);
  };

  const payoutAcct = location?.state?.fileData.payoutAccount;
  const destinationAcct = location?.state?.fileData.destination; // No longer needed - moved to success page

  function sortObject(obj) {
    return Object.keys(obj)
      .sort()
      .reduce((a, v) => {
        a[v] = obj[v];
        return a;
      }, {});
  }

  const initiateTransfer = async (url: any, dataObj: any, otp: string) => {
    const sortObjectx = sortObject(dataObj);
    const signature = await encryptPayload(
      JSON.stringify(sortObjectx).replace(/{|}|"|:|,| /g, '')
    );

    try {
      const res = await axios.post(
        url,
        { ...dataObj, signature },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${props.bearerToken}`,
            'Public-Key': `${props.public_key}`,
          },
        }
      );

      if (res.data.code === 'error') {
        setLoading(false);
        Alert('error', res.data.code);
      } else {
        await getAnalytics();
        await checkAllPrimaryPockets();
        setLoading(false);
        // Navigate to success page with transaction data
        navigate('/dashboard/disbursement/transaction_success', {
          state: {
            transactionData: location?.state?.fileData,
            transactionMode: transactionMode,
          },
        });
      }

      return res;
    } catch (error) {
      setLoading(false);
      handleException(error);
    }
  };

  const requestOTP = async (dataObj: any) => {
    setLoading(true);
    try {
      const res = await axios.post(
        `https://pocket.seerbitapi.com/winner/sendOtp`,
        {
          ...dataObj,
          ...(location?.state?.detailedOTPOptIn
            ? {             pocketId:
                  location?.state?.fileData?.payoutAccount ||
                  location?.state?.pocketID ||
                  undefined,
                transactionDetails: {
                  transactionReference:
                    location?.state?.fileData?.transactionRef || undefined,
                  narration:
                    location?.state?.fileData?.transactionPurpose || undefined,
                  pocketId:
                    location?.state?.fileData?.payoutAccount ||
                    location?.state?.pocketID ||
                    undefined,
                  amount:
                    Number(location?.state?.fileData?.amount) || undefined,
                  currency: location?.state?.fileData?.currency || 'NGN',
                  beneficiaryName:
                    location?.state?.fileData?.accountName || undefined,
                  beneficiaryAccountNumber:
                    location?.state?.fileData?.destination || undefined,
                  beneficiaryBankCode:
                    location?.state?.fileData?.bankcode || undefined,
                  transactionType: location?.state?.mode === "bank_tf" ? "BANK_TRANSFER" : "POCKET_TRANSFER"
                },
              }
            : {}),
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${props.bearerToken}`,
          },
        }
      );

      if (res.data.code === 'error') {
        setLoading(false);
        Alert('error', res.data.code);
      } else {
        setLoading(false);
        Alert('success', 'Next, Validate OTP');
      }

      return res;
    } catch (error) {
      setLoading(false);
      handleException(error);
      Alert('error', 'Failed');
    }
  };

  const verifyOTP = async (verifyObj: any) => {
    setLoading(true);
    try {
      // const res = await  axios.post(`https://pocket.seerbitapi.com/winner/otp-verify`, verifyObj, {
      //     headers: {
      //         "Content-Type": "application/json",
      //         "Authorization": `Bearer ${props.bearerToken}`
      //     }
      // })

      // if(res.data.code === 'error'){
      //     setLoading(false)
      //     Alert('error', res.data.code);
      // }else{
      //     Alert('success','OTP Validated');

      const toPocket_Data = {
        amount: location?.state?.fileData.amount,
        currency: location?.state?.fileData?.currency || 'NGN',
        reference: location?.state?.fileData.transactionRef,
        description: location?.state?.fileData.transactionPurpose
          .replace(',', '')
          .replace('.', ''),
        passKey: verifyObj.otp,
      };

      const toBank_Data = {
        reference: location?.state?.fileData.transactionRef,
        amount: location?.state?.fileData.amount,
        currency: location?.state?.fileData?.currency || 'NGN',
        description: location?.state?.fileData.transactionPurpose,
        accountNumber: location?.state?.fileData.destination,
        bankCode: location?.state?.fileData.bankcode,
        passKey: verifyObj.otp,
      };

      const toMobileMoney = {
        reference: location?.state?.fileData?.transactionRef,
        amount: location?.state?.fileData?.amount,
        currency: location?.state?.fileData?.currency,
        description: location?.state?.fileData?.transactionPurpose,
        momoNumber: location?.state?.fileData?.mobileNumber,
        momoCode: location?.state?.fileData?.network?.value,
        passKey: verifyObj?.otp,
      };

      const url =
        transactionMode === 'bank_tf'
          ? `https://pocket.seerbitapi.com/pocket/payout/encrypted/pocket-id/${payoutAcct}`
          : transactionMode === 'mobile_money'
          ? // ? `https://pocket.seerbitapi.com/pocket/momo-payout/V2/pocket-id/${payoutAcct}/country/${location?.state?.fileData?.country}`
            `https://pocket.seerbitapi.com/pocket/v2/momo-payout/pocket-id/${payoutAcct}/country/${location?.state?.fileData?.country}`
          : `https://pocket.seerbitapi.com/pocket/transfer/from-pocket/${payoutAcct}/to-pocket/${destinationAcct}`;

      const transactionData =
        transactionMode === 'bank_tf'
          ? toBank_Data
          : transactionMode === 'mobile_money'
          ? toMobileMoney
          : toPocket_Data;

      initiateTransfer(url, transactionData, verifyObj.otp);

      return;
    } catch (error) {
      setLoading(false);
      handleException(error);
    }
  };

  // Confirmation modal for canceling transaction
  const confirmationContent = showPrompt && (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md mx-4">
        <Prompts
          promptSetting={promptSetting}
          action={true}
          handleClose={() => {
            setShowPrompt(false);
          }}
          handleConfirm={() => {
            Alert('success', 'Transaction terminated');
            navigate('/dashboard/disbursement/single');
            setShowPrompt(false);
          }}
        />
      </div>
    </div>
  );

  const handleValidateOTP = () => {
    if (OTPChange === '' || OTPChange.length < 6) {
      Alert('error', 'Please enter the complete OTP.');
    } else {
      verifyOTP({
        otp: OTPChange,
        email: userName,
        category: actionItemValue,
      });
    }
  };

  // This function is no longer needed as we're navigating to a new page
  // const handleRedirect = () => {
  // 	props.toggleModal();
  // 	navigate('/dashboard/transactions');
  // };
  // Transaction status component removed - now using dedicated success page

  return (
    <div className="flex flex-col gap-5 justify-between">
      <PageTitle pageTitle="Authentication" pageTitleStyle="font-bold" />

      <div className="py-5 mobile:p-0 rounded-[15px] min-h-[70vh] mobile:min-h-fit mobile:my-[4rem] mobile:rounded-[10px] mobile:shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px] overflow-y-scroll custom_container mb-10">
        <div className="flex justify-center items-center min-h-[65vh] mobile:min-h-fit p-5 mobile:p-0 rounded-[15px]">
          <div className="flex flex-col gap-16 justify-between items-center w-[515px] mobile:w-full min-h-[350px] mobile:min-h-[200px] p-10 mobile:p-5 bg-white rounded-[10px] shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px]">
            {loading && (
              <div
                className={`absolute z-10 left-0 top-0 flex items-center py-10 justify-center rounded-[15px] bg-white bg-opacity-80 w-full h-full`}
              >
                <Spinner text="Validating OTP..." textStyle="text-lg" />
              </div>
            )}

            <div className="flex flex-col gap-8">
              <span className="font-semibold text-2xl leading-[28.8px] text-black">
                Enter One Time Passcode
              </span>
              <span className="font-normal text-lg leading-[30px] text-SecondaryAccent">
                Please enter the 6-digit OTP sent to the assigned signatory
                Email
              </span>
            </div>
            <div className="w-fit flex flex-col justify-center items-center gap-3">
              <CodeInput
                length={6}
                onChange={(v) => setOTPChange(v)}
                type={'numeric'}
                secret={true}
                onComplete={handleOTPComplete}
              />
              <div className="flex justify-center items-center gap-1">
                <span className="text-zinc-950 text-[15px] font-normal font-['Blinker'] leading-[30px]">
                  Didn’t receive the OTP?
                </span>
                <div
                  className={`flex items-center gap-1 text-red-600 text-[15px] font-normal font-['Blinker'] leading-[30px]`}
                >
                  <span
                    onClick={() => requestOTP({ actionItem: actionItemValue })}
                    className="cursor-pointer"
                  >
                    Resend
                  </span>
                  {/* {showTimer && (<CountdownTimer initialSeconds={60}/>)} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between items-center absolute w-full bottom-0 left-0 py-8 px-16 mobile:py-4 mobile:px-10 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
        <Button
          btnType="button"
          btnText="Cancel"
          btnStyle="brounded-lg truncate flex gap-3 justify-center items-center w-[216px] mobile:w-fit mobile:px-8 px-3 py-2 font-semibold text-sm border border-gray-200 leading-7 flex-row-reverse rounded-lg truncate"
          disabled={loading ? true : false}
          disabledClass="cursor-not-allowed"
          onClick={() => setShowPrompt(true)}
        />
        <Button
          btnType="button"
          btnText="Validate OTP"
          btnStyle="bg-DarkBg3 text-white rounded-lg truncate flex gap-3 justify-center items-center w-[216px] mobile:w-fit mobile:px-8 px-3 py-2 font-semibold flex-row-reverse rounded-lg truncate create-button"
          disabled={false}
          disabledClass="cursor-not-allowed"
          onClick={handleValidateOTP}
        />
      </div>

      {confirmationContent}

      {/* Modal is no longer needed - using new success page instead */}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  bearerToken: state.auth.token,
  public_key: state.auth.public_key,
  pocketId: state.auth.pocket_data?.pocketId,
  allPrimaryPockets: state.pocket.allPrimaryPockets,
  pocketAccountInfo: state.pocket.pocketAccountInfo,
  primaryPocket_details: state.pocket.primaryPocket_details,
  pocket_data: state.auth.pocket_data,
  dashboardAnalytics: state.pocket.dashboardAnalytics,
});

const mapDispatchToProps = (dispatch: any) => ({
  setBatchID: (id: any) => dispatch(setBatchID(id)),
  cancelFileUpload: () => dispatch(cancelFileUpload()),
  seAlltPocketDetails: (data: any) => dispatch(seAlltPocketDetails(data)),
  setDashboardAnalytics: (data: any) => dispatch(setDashboardAnalytics(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ValidateOTP);
